import component from "./SectionHeader";
export default component;
